import dayjs from 'dayjs';

import { KentRebalancingSchedule } from '@cast/types-kent';

/**
 * Returns the enabled schedule with the soonest `nextScheduleTime`.
 * Disabled schedules are never triggered, so they are excluded.
 * Returns `undefined` when no enabled schedule has an upcoming trigger time.
 */
export const getSoonestRebalancingSchedule = (
  schedules: KentRebalancingSchedule[]
): KentRebalancingSchedule | undefined => {
  return schedules
    .filter((schedule) => schedule.enabled && !!schedule.nextScheduleTime)
    .sort(
      (scheduleA, scheduleB) =>
        dayjs(scheduleA.nextScheduleTime).valueOf() -
        dayjs(scheduleB.nextScheduleTime).valueOf()
    )[0];
};
